import React, { useState } from "react";
import Modal from "../../../parts/modal-new";
import { upperFirst, round } from "lodash";
import { useTranslation } from "react-i18next";

const LIFTING_STANDARDS = {
  squat: 0.23,
  bench: 0.1,
  deadlift: 0.14,
};
const VelocityModal = ({ hideVelocitySettings, thresholds, setThresholds }) => {
  const { t } = useTranslation("dashboard");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        data-button-type="tertiary"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
        disabled={hideVelocitySettings}
      >
        {t("velocityModal.modifyMvt")}
      </button>
      <Modal
        title={t("velocityModal.title")}
        className={`velocity-modal ${isOpen ? "" : "hidden!"}`}
        onClose={() => setIsOpen(false)}
      >
        <div className="body">
          <h4 className="mt-2 mb-6">{t("velocityModal.minimumVelocityThreshold")}</h4>
          <p className="p5">{t("velocityModal.mvtDescription1")}</p>
          <p className="p5 mt-2 mb-12">{t("velocityModal.mvtDescription2")}</p>

          <header>
            <span></span>
            <span>{t("velocityModal.industryStandardMvt")}</span>
            <span>{t("velocityModal.modification")}</span>
            <span>{t("velocityModal.modifiedMvt")}</span>
          </header>

          {["squat", "bench", "deadlift"].map((lift) => (
            <div className="velocity-table-row" key={`${lift}-velocity`}>
              <div>
                <span>{t(`velocityModal.${lift}`)}</span>
              </div>
              <span>{LIFTING_STANDARDS[lift]}</span>
              <div className="velocity-threshold-control">
                <button
                  data-button-type="secondary"
                  data-icon-only
                  onClick={(e) => {
                    e.preventDefault();
                    setThresholds({
                      ...thresholds,
                      [lift]: thresholds[lift] - 0.01,
                    });
                  }}
                >
                  <img
                    src="/img/new-icons/less-gradient.svg"
                    alt="minus-velocity"
                  />
                </button>
                <input
                  type="text"
                  name={`${lift}Threshold`}
                  className="velocity-threshold-control-input"
                  readOnly
                  value={round(thresholds[lift], 3).toFixed(2)}
                />
                <button
                  data-button-type="secondary"
                  data-icon-only
                  onClick={(e) => {
                    e.preventDefault();
                    setThresholds({
                      ...thresholds,
                      [lift]: thresholds[lift] + 0.01,
                    });
                  }}
                >
                  <img
                    src="/img/new-icons/add-gradient-icon.svg"
                    alt="plus-velocity"
                  />
                </button>
              </div>
              <span>
                {(LIFTING_STANDARDS[lift] + thresholds[lift]).toFixed(2)}
              </span>
            </div>
          ))}
        </div>
        <footer>
          <button
            data-button-type="secondary"
            data-action="cancel"
            onClick={(e) => {
              e.preventDefault();
              setIsOpen(false);
            }}
          >
            {t("common:cancel")}
          </button>
          <button
            data-button-type="primary"
            onClick={(e) => {
              e.preventDefault();
              setIsOpen(false);
            }}
          >
            {t("common:save")}
          </button>
        </footer>
      </Modal>
    </>
  );
};

export default VelocityModal;
